// NPC プリセット（名前・絵文字）
export const NPC_PRESETS = [
  { nickname: 'ボット太郎', emoji: '🤖' },
  { nickname: 'ぼっと花子', emoji: '🐱' },
  { nickname: 'ロボ次郎', emoji: '⚙️' },
  { nickname: 'AI山田', emoji: '🧠' },
  { nickname: 'CPU佐藤', emoji: '💾' },
  { nickname: 'NPCゆうこ', emoji: '👾' },
  { nickname: 'ザ・ボット', emoji: '🦾' },
];

// NPC が submit するテキスト回答のプール（汎用）
export const NPC_TEXT_ANSWERS = [
  'ありません',
  'それな',
  '考え中…',
  '知らんけど',
  '覚えてない',
  '上司に聞きます',
  '気合いで！',
  'AIに聞いて',
  'うーん…',
  '言えません',
  '微妙です',
  '🤔',
  '意外と良い感じ',
  'マジでそれ',
  'たぶん',
  '永遠の謎',
  '言わぬが花',
  'ChatGPTに聞いて',
  '検討します',
  '人間には早すぎる',
  '世はまさに大ボット時代',
  '今日もお疲れさま',
  'バグです',
  '仕様です',
  'NaN',
];

export function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// NPC のスコアを「微妙〜まあまあ」の分布で生成（★1〜5、ランダム）
export function rollNpcScore() {
  // 重み付き: ★3 が最頻、たまに★5、たまに★1
  const r = Math.random();
  if (r < 0.05) return 5;
  if (r < 0.20) return 4;
  if (r < 0.55) return 3;
  if (r < 0.85) return 2;
  return 1;
}
